/**
 * True when Microsoft SSO failed because the user is not provisioned in Funnel Fuel (request-access flow).
 * API copy varies slightly (SP vs controller); keep conditions broad.
 */
export function isMicrosoftNotRegisteredError(title, message) {
  const t = (title || "").toLowerCase();
  const m = (message || "").toLowerCase();
  if (t.includes("unable to complete sign-in")) {
    if (m.includes("not registered")) return true;
    if (m.includes("cannot sign in") || m.includes("not authorized to sign")) return true;
    if (m.includes("microsoft account") && (m.includes("funnel") || m.includes("administrator") || m.includes("provision"))) return true;
  }
  if (m.includes("microsoft account is not registered")) return true;
  if (m.includes("not registered in funnel")) return true;
  if (m.includes("account not found") && m.includes("microsoft")) return true;
  return false;
}
